import {FunnelsQuery} from 'common/report/funnels/models/funnels-query';
import {FunnelToCommonChartTypeMap} from 'common/report/funnels/models/types';
import {getLiftTypeOverrides} from 'common/report/util/lift/overrides';
import {LiftTypeOverrides} from 'common/report/util/lift/types';

export function getLiftTypeOverridesForFunnels(query: FunnelsQuery): LiftTypeOverrides {
  const {chartType} = query;

  const commonChartType = FunnelToCommonChartTypeMap[chartType];

  return getLiftTypeOverrides(commonChartType);
}
